import { create } from 'zustand';

const useTableHeader = create((set) => ({
  headers: {},
  setHeaders: (id, headers) =>
    set((state) => ({ headers: { ...state.headers, [id]: headers } }))
}));

export default useTableHeader;
